import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-doc-viewer',
  templateUrl: './doc-viewer.component.html',
  styleUrls: ['./doc-viewer.component.scss']
})
export class DocViewerComponent implements OnInit {

  @Input() url:string;
  @Input() isImage:boolean=false;
  @Input() viewerType:string="google";
  constructor() { }

  //* FUNCIONES ANGULAR

  ngOnInit() {
  }

  //* END FUNCIONES ANGULAR

}
